import { useQuery } from "@tanstack/react-query";

import { getTimeSettings } from "@/adapters/api";
import { useActiveContext } from "@/store/use-active-context";

export function useTimeSettings() {
	const activeCanteiroId = useActiveContext((state) => state.activeCanteiroId);

	return useQuery({
		queryKey: ["time-settings", activeCanteiroId],
		enabled: activeCanteiroId != null,
		queryFn: () => getTimeSettings(activeCanteiroId as string),
	});
}
